import { render } from "./StandardUpload.vue?vue&type=template&id=7f8c5cb2&scoped=true"
import script from "./StandardUpload.vue?vue&type=script&lang=js"
export * from "./StandardUpload.vue?vue&type=script&lang=js"

import "./StandardUpload.vue?vue&type=style&index=0&id=7f8c5cb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8c5cb2"]])

export default __exports__